import { useState, useRef, useCallback } from 'react'

interface BetaBadgeProps {
  compact?: boolean
}

export default function BetaBadge({ compact }: BetaBadgeProps) {
  const [pos, setPos] = useState<{ top: number; left: number } | null>(null)
  const badgeRef = useRef<HTMLSpanElement>(null)
  const hideTimeout = useRef<ReturnType<typeof setTimeout> | null>(null)

  const showTooltip = useCallback(() => {
    if (hideTimeout.current) {
      clearTimeout(hideTimeout.current)
      hideTimeout.current = null
    }
    if (!badgeRef.current) return
    const rect = badgeRef.current.getBoundingClientRect()
    setPos({ top: rect.bottom, left: rect.left })
  }, [])

  const hideTooltip = useCallback(() => {
    hideTimeout.current = setTimeout(() => setPos(null), 150)
  }, [])

  const tooltipEnter = useCallback(() => {
    if (hideTimeout.current) {
      clearTimeout(hideTimeout.current)
      hideTimeout.current = null
    }
  }, [])

  return (
    <span className="relative" ref={badgeRef} onMouseEnter={showTooltip} onMouseLeave={hideTooltip} onClick={(e) => e.preventDefault()}>
      <span
        className={
          compact
            ? 'px-1 py-0.5 text-[10px] font-semibold rounded bg-blue-500/15 text-blue-500 leading-none'
            : 'px-1.5 py-0.5 text-xs font-semibold rounded bg-blue-500/15 text-blue-500'
        }
      >
        Beta
      </span>
      {pos && (
        <span
          className="fixed w-64 pt-2 z-[9999]"
          style={{ top: pos.top, left: pos.left }}
          onMouseEnter={tooltipEnter}
          onMouseLeave={hideTooltip}
        >
        <span className="block w-full p-3 rounded-lg bg-card border border-border shadow-lg text-sm text-card-foreground">
          <span className="font-medium block mb-1">Code Concierge is in beta</span>
          <span className="text-muted-foreground text-xs leading-relaxed block">
            The platform is in active development. You may experience brief interruptions
            as updates are deployed. For persistent issues, reach out in{' '}
            <a href="https://exante.slack.com/archives/C0ACURB6A9X" target="_blank" rel="noopener noreferrer" className="text-blue-500 font-medium hover:underline" onClick={(e) => e.stopPropagation()}>#team-claude</a> on Slack.
          </span>
        </span>
        </span>
      )}
    </span>
  )
}
